import pdfMake from 'pdfmake/build/pdfmake';
import {TDocumentDefinitions} from "pdfmake/interfaces";
import {formatDate, formatPeso} from '../helpers';
import {calAmortizacion} from '../services';
import {IAmortizacion} from "../redux/types/IPrestamo";
import {store} from "../redux/store";
import {CICLOS_PAGO, getValueString, TIPO_AMORTIZACION} from "../helpers/CONSTANTES";
import {getColor} from "../assets/colors";

const fonts = require('./fonts/fonts');


export async function reporteAmortizacion({params}:{params: any}) {
    let compania = store.getState().companias.data;
    let {uiColor} = store.getState().auth.user ?? {};
    let color = getColor(uiColor)
    let data:IAmortizacion[] = [];
    let {
        cicloPago,
        cuotas,
        fechaPrimerPago,
        monto,
        tasa,
        tipoAmortizacion,
        comision,
        montoSeguro,
    } = params
    await calAmortizacion(params).then(res=>{
        data = res.data
    })

    //
    // let data = buildAmort(monto,tasa,cuotas,cicloPago,tipoAmortizacion,fechaPrimerPago);
    //




    pdfMake.vfs = fonts.pdfMake.vfs;
    pdfMake.fonts = {
        'Calibri': {
            normal: `Calibri_Regular.ttf`,
            bold: `Calibri_Bold.ttf`,
            italics: `Calibri_Light_Italic.ttf`,
            bolditalics: `Calibri_Bold_Italic.ttf`
        },
    }
    // www.prestamistapp.com
    // Sistema para Administración de Prestamos.

    let docDefinition:TDocumentDefinitions = {
        pageMargins:20,
        // pageSize: "LEGAL",
        info: {
            title: 'Cronograma de Pagos',
            author: 'dsegura.net',
            creator: 'prestamistapp.com',
        },
        // pageOrientation:'landscape',
        content: [
            {
                layout:"noBorders",
                table: {
                    widths: ['*', '*'],
                    body: [
                        [
                            compania?.logo ?
                            {
                                image: "logo",
                                fit: [70, 50],
                                // opacity: 0.5,
                                marginTop: 7
                            }:{},
                            [
                                {text: compania?.nombre ?? "", alignment:"right", fontSize:17, color:color.primary.main},
                                ...(compania?.rnc ? [{text: "RNC: "+compania?.rnc, alignment: "right"}]: []),
                                {text: [
                                        "Tel: "+ compania?.telefono ?? "",
                                        (compania?.telefono2 ? " / "+compania.telefono2 : ""),
                                    ], alignment:"right", fontSize:10},

                                {text: compania?.direccion ?? "" , alignment:"right", fontSize:10},
                            ]
                        ],
                    ]
                }
            },
            {
                canvas: [
                    {
                        type: 'line',
                        x1: 0,
                        y1: 10,
                        x2: 555,
                        y2: 10,
                        lineWidth: 0.5,
                        lineColor:"#d3d3d3",
                        strokeOpacity:0.5
                    }
                ],
                marginBottom:10,
            },
            // {
            //     table: {
            //         widths: ['*'],
            //         body: [[" "], [" "]]
            //     },
            //     layout: {
            //         hLineWidth: function(i, node) {
            //             return (i === 0 || i === node.table.body.length) ? 0 : 0.5;
            //         },
            //         vLineWidth: function(i, node) {
            //             return 0;
            //         },
            //         hLineColor: function (i, node) {
            //
            //             return '#666';
            //
            //         },
            //     }
            // },
            {text: "CRONOGRAMA DE PAGOS", alignment:"left", fontSize:17,margin:[0,10], color:color.primary.main},

            {
                layout:"noBorders",
                table: {
                    widths: ["*"],
                    body: [
                        [
                            {
                                layout:"noBorders",
                                margin:8,
                                fillColor:"#f5f5f5",
                                table: {
                                    widths: ['*', '*', '*'],
                                    body: [
                                        [
                                            {
                                                text: [
                                                    {text: "Fecha: ", bold:true}, {text: formatDate(fechaPrimerPago)},
                                                ],
                                                marginBottom: 4
                                            },
                                            {
                                                text: [
                                                    {text: "Capital Inicial: ", bold:true}, {text: formatPeso(monto)},
                                                ],
                                                marginBottom: 4
                                            },
                                            {
                                                text: [
                                                    {text: "Tipo Amortización: ", bold:true}, {text: getValueString(TIPO_AMORTIZACION, +tipoAmortizacion) },
                                                ],
                                                marginBottom: 4
                                            },
                                        ],
                                        [
                                            {
                                                text: [
                                                    {text: "Interés: ", bold:true}, {text: "% "+tasa},
                                                ],
                                                marginBottom: 4
                                            },
                                            {
                                                text: [
                                                    {text: "Ciclo Pago: ", bold:true}, {text: getValueString(CICLOS_PAGO, +cicloPago)},
                                                ],
                                                marginBottom: 4
                                            },
                                            {
                                                text: [
                                                    {text: "Cuotas: ", bold:true}, {text: cuotas},
                                                ],
                                                marginBottom: 4
                                            },
                                        ],
                                        [
                                            {
                                                text: [
                                                    {text: "Comisión: ", bold:true}, {text: "% "+comision},
                                                ],
                                                marginBottom: 4
                                            },
                                            {
                                                text: [
                                                    {text: "Seguro: ", bold:true}, {text: formatPeso(montoSeguro??0)},
                                                ],
                                                marginBottom: 4
                                            },
                                            {
                                                text:"",
                                                marginBottom: 4
                                            },
                                        ],

                                    ]

                                }
                            },
                        ]
                    ]

                }
            },
            {
                layout:"noBorders",
                fillColor:"#f5f5f5",
                marginTop:4,
                marginBottom:1,
                table: {
                    widths: ['*'],
                    body: [
                        [
                            {text: "Amortización", fontSize:12, bold:true, color:color.secondary.main, margin:[8,4]},
                        ],
                    ]

                }
            },

            {
                fontSize:10,
                table: {
                    widths: ['*','*','*','*','*','*','*'],
                    body: [
                        [
                            {text: "No - Fecha", style:"titleCel"},
                            {text: "Cuota", alignment:"right", style:"titleCel"},
                            {text: "Interés", alignment:"right", style:"titleCel"},
                            {text: "Capital", alignment:"right", style:"titleCel"},
                            {text: "Seguro", alignment:"right", style:"titleCel"},
                            {text: "Comisión", alignment:"right", style:"titleCel"},
                            {text: "Balance", alignment:"right",style:"titleCel"}
                        ],
                        ...data?.map((item, index)=>[
                            {text: item.cuota+" - "+formatDate(item.fecha)},
                            {text: formatPeso(item.total), alignment:"right"},
                            {text: formatPeso(item.interes), alignment:"right"},
                            {text: formatPeso(item.capital), alignment:"right"},
                            {text: formatPeso(item.seguro), alignment:"right"},
                            {text: formatPeso(item.comision), alignment:"right"},
                            {text: formatPeso(item.capitalPendiente), alignment:"right"},
                        ]) ?? [],
                        [
                            {text: "TOTALES:",style:"footerCel"},
                            {text: "",style:"footerCel"},
                            {text: formatPeso(monto), alignment:"right", style:"footerCel"},
                            {text: formatPeso(data?.reduce((a, b) => +a + (b.interes??0), 0)), alignment:"right", style:"footerCel"},
                            {text: formatPeso(data?.reduce((a, b) => +a + (b.total??0), 0)), alignment:"right", style:"footerCel"},
                            {text: formatPeso(data?.reduce((a, b) => +a + (b.seguro??0), 0)), alignment:"right", style:"footerCel"},
                            {text: formatPeso(data?.reduce((a, b) => +a + (b.comision??0), 0)), alignment:"right", style:"footerCel"}
                        ],
                    ],

                },
                layout: {
                    hLineWidth: function (i, node) {
                        if(i === 0 || i === node.table.body.length){
                            return 0
                        }else if(i === 1){
                            return 2
                        }
                        return 1;
                    },
                    vLineWidth: function (i, node) {
                        return 0
                        // return (i === 0 || i === node.table.widths?.length) ? 0 : 1;
                    },
                    hLineColor: function (i, node) {
                        if(i === 1){
                            return color.primary.main;
                        }
                        return '#e3e3e3';

                    },
                    // vLineColor: function (i, node) {
                    //     return null;
                    // },
                    // hLineStyle: function (i, node) {
                    //     if (i === 0 || i === node.table.body.length) {
                    //         return null;
                    //     }
                    //     return {dash: {length: 10, space: 4}};
                    // },
                    // vLineStyle: function (i, node) {
                    //     if (i === 0 || i === node.table.widths?.length) {
                    //         return null;
                    //     }
                    //     return {dash: {length: 4}};
                    // },
                    paddingLeft: function(i, node) { return 5; },
                    paddingRight: function(i, node) { return 5; },
                    paddingTop: function(i, node) { return 5; },
                    paddingBottom: function(i, node) { return 5; },
                    fillColor: function (i, node) {
                        if (i === 0){
                            return "#f5f5f5";
                        }
                        return null;
                    }
                }
            },
        ],
        footer: {
            margin:[16,0],
            columns: [
                {
                    text: [
                        'www.prestamistapp.com'
                    ],
                    link: 'https://prestamistapp.com/',
                    color:"blue",
                    alignment:"right",
                    fontSize:10,
                },
                // {
                //     text: "Sistema para Administración de Prestamos.",
                //     alignment: 'right'
                // }
            ]
        },
        styles: {
            blueCell:{
                fillColor:"#bbbbbb",
            },

            blueCellBold:{
                fillColor:"#bbbbbb",
                bold: true,

            },
            footerCel:{
                bold:true,
                color:"#666"
                // fillColor:"#f5f5f5",
                // fontSize: 11
            },
            titleCel:{
                // fillColor:"#f5f5f5",
                color:color.primary.main,
                margin :2,
                fontSize: 11,
                // color: '#FFF',
                bold: true,
              //  fontSize: 8,
            },
            table: {
                margin: [0, 5, 0, 5],
            },
            tableHeader: {
                bold: true,
               // fontSize: 11,
              //  fillColor:"#023465",
                color: 'black'
            }
        },
        images:{
          logo: compania?.logo ?? ""
        },
        defaultStyle: {
            fontSize: 11,
            font: 'Calibri'
            // alignment: 'justify'
        }
    }


    const pdfDocGenerator = pdfMake.createPdf(docDefinition);

    return Promise.resolve(pdfDocGenerator);
}


export interface IFormulario {
    idSolicitud: number
    generales: Generales
    relacionBanco: {
        tipoProducto?: string
        codigoProducto?: string
        montoOriginal?: number
        capital?: number
        cuota?: number
        atraso?: number
        montoVencido?: number
        tipoRelacion?: string
        estadoProducto?: string
        claseProducto?: string
    }[]
}

export interface Generales {
    nombre: string
    fecha: string
    identificacion: string
}
